import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/ativPlantio' };
const argsCustoDireto = { ...path, path: '/custoDireto' };
/////////////////////////////////////////////////////////////////////////////////

export function createPlantioManejo(payload) {
  return httpService.post(args, payload);
}

export function createPlantioManejoMulti(payload) {
  return httpService.post({ ...args, args: '/saveAll' }, payload);
}

export function updatePlantioManejo(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listPlantioManejo(idPropriedade, idSafraAtiva, datas, where) {
  return httpService.get({ ...args, args: `/getLancamentosSafraResumed?propriedade=${idPropriedade}&safra=${idSafraAtiva}&datas=${datas}${where}` });
}

export function listPlantioManejoTable(param) {
  return httpService.get({ ...args, args: param });
}

export function findPlantioManejo(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deletePlantioManejo(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function getCustoTotalSafra(idPropriedade, idSafraAtiva, datas, where) {
  return httpService.get({ ...args, args: `/getTotaisCustoSafra?propriedade=${idPropriedade}&safra=${idSafraAtiva}&datas=${datas}${where}` });
}

export function createPlantioManejoCustoDireto(payload) {
  return httpService.post(argsCustoDireto, payload);
}

export function updatePlantioManejoCustoDireto(payload) {
  const { id } = payload

  return httpService.put({ ...argsCustoDireto, args: `/${id}` }, payload);
}

export function deletePlantioManejoCustoDireto(id) {
  return httpService.del({ ...argsCustoDireto, args: `/${id}` });
}

export function importPlanejamento(id) {
  return httpService.get({ ...args, args: `/realizarPlanejamento/${id}` });
}

export function getPlantiosByPlanejamento(id) {
  return httpService.get({ ...args, args: `/plantiosByPlanejamento/${id}` });
}

export function getRelatorioAtividadesTalhaoSintetico(idPropriedade, idSafraAtiva, datas, where, mostrarCusto) {
  return httpService.getPdf({ ...args, args: `/relatorioAtividadesTalhaoSintetico/pdf/${mostrarCusto}?propriedade=${idPropriedade}&safra=${idSafraAtiva}&datas=${datas}${where}` });
}

export function getRelatorioAtividadesTalhaoAnalitico(idPropriedade, idSafraAtiva, datas, where, idAplicacao, mostrarCusto) {
  return httpService.getPdf({ ...args, args: `/relatorioAtividadesTalhaoAnalitico/pdf/${mostrarCusto}?propriedade=${idPropriedade}&safra=${idSafraAtiva}&datas=${datas}${where}${idAplicacao}` });
}

export function getSafraPossuiPendenciaEstoque(idPropriedade, idSafra) {
  return httpService.get({ ...args, args: '/safraPossuiPendenciaEstoque/' + idPropriedade + '/' + idSafra });
}

export function reprocessarEstoquePendente(idPropriedade, idSafra) {
  return httpService.post({ ...args, args: '/reprocessStock/' + idPropriedade + '/' + idSafra });
}

export function getProdutosEstoquePendente(idPropriedade, idSafra) {
  return httpService.get({ ...args, args: '/produtosEstoquePendente/' + idPropriedade + '/' + idSafra });
}